/**
 * Art eines Mitglieds
 */
export enum MembershipType {
   /**
    * Normale Mitgliedschaft
    */
   normal = "normal",

   /**
    * Fördermitglied
    */
   sponsor = "sponsor",

   /**
    * Gruppenunfallversucherung
    */
   insurance = "insurance"
}

export const MembershipTypeNames = {
   normal: "Normale Mitgliedschaft",
   sponsor: "Fördermitgliedschaft",
   insurance: "Versicherung"
};